export enum MicrositeEmailType {
    CenterConfirmedPatient = 10,
    CenterNotifyDeclineFixable = 20,
    CenterNotifyDeclineFixableForChanges = 25,
    CenterNotifyDeclineUnfixable = 30,
    CenterNotifyDeclineUnfixableForChanges = 35,
    CenterRequestApproval = 40,
    CenterRequestApprovalForChanges = 45,
    ConfirmSelfRegistration = 50,
    DeactivatedInformCoach = 60,
    MailingRequestAlert = 70,
    MailingRequestCancel = 80,
    NkrApproved = 90,
    NkrApprovedForChanges = 100,
    OrderCampaignBrochures = 110,
    RecipientApproved = 120,
    RecipientApprovedForChanges = 125,
    RecipientAssignedCoach = 130,
    RecipientDeclineFixable = 140,
    RecipientDeclineFixableForChanges = 145,
    RecipientDeclineUnfixable = 150,
    RecipientDeclineUnfixableForChanges = 155,
    RecipientInvitation = 160,
    RecipientReminder = 170,
    RecipientStarterSiteActivation = 180,
    RecipientWeekly = 190,
    RecipientDashboardLink = 200
}